import React from "react";
import { Button } from "@mui/material";
import Modal from "../../../shared/components/ui/Modal";
import StatusBadge from "../../../shared/components/common/StatusBadge";

const toTitleCase = (value) => {
  const raw = String(value || "").toLowerCase();
  if (!raw) return "Unknown";
  return raw.charAt(0).toUpperCase() + raw.slice(1);
};

const PaymentMethodDetailsModal = ({
  show,
  onClose,
  details,
  isLoading = false,
  errorMessage = "",
}) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      className="!w-[85%] shadow !rounded-2xl max-sm:!p-6 sm:!max-w-[520px]"
      bodyClass="!px-0"
      header={<h2 className="text-xl font-bold text-primary text-left">Payment Method Details</h2>}
      description={<p className="text-md text-darkgray mt-1 text-left">View selected payment method information</p>}
      footer={
        <div className="flex justify-end">
          <Button onClick={onClose} variant="outlined">
            CLOSE
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 py-4 pr-2">
        {isLoading ? (
          <p className="text-sm text-mutedLight">Loading payment method details...</p>
        ) : errorMessage ? (
          <p className="text-sm text-red-600">{errorMessage}</p>
        ) : (
          <div className="space-y-3">
            <div>
              <p className="text-xs text-muted uppercase tracking-wide">Cardholder Name</p>
              <p className="text-sm text-content font-semibold">{details?.cardholderName || "N/A"}</p>
            </div>
            <div>
              <p className="text-xs text-muted uppercase tracking-wide">Card Number</p>
              <p className="text-sm text-content font-semibold">{details?.maskedCardNumber || "N/A"}</p>
            </div>
            <div>
              <p className="text-xs text-muted uppercase tracking-wide">Expiry Date</p>
              <p className="text-sm text-content font-semibold">{details?.expiryDate || "N/A"}</p>
            </div>
            <div>
              <p className="text-xs text-muted uppercase tracking-wide mb-1">Card Status</p>
              <StatusBadge status={toTitleCase(details?.cardStatus)} />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PaymentMethodDetailsModal;
